/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.S30PLUS_MODELS = {
    '215'                                       : [ 'Nokia', '215' ],
    '220'                                       : [ 'Nokia', '220' ],
    '222'                                       : [ 'Nokia', '222' ],
    '225'                                       : [ 'Nokia', '225' ],
    '230'                                       : [ 'Nokia', '230' ]
};

/* This file is automatically generated, do not edit manually! */
